import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.css'],
    standalone: false
})
export class ConfirmationModalComponent {
  actionType: string = '';
  adminBool: boolean = false;
  activateBool: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.actionType = data.type;
    this.adminBool = data.isAdmin;
    this.activateBool = data.isActive;
  }

  /**
   * Closes the modal with details on what field to update to what value.
   */
  toggleField() {
    this.dialogRef.close({ type: this.actionType, isAdmin: this.adminBool, isActive: this.activateBool });
  }

  /**
   * Closes the modal with a falsy value.
   */
  close() {
    this.dialogRef.close(false);
  }
}
